import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { PageHeader } from '../../components/ui/PageHeader';
import { BuildYourOwn } from '../../components/shop/BuildYourOwn';
import { pricingConfig } from '../../data/pricing';
import { useLanguage } from '../../contexts/LanguageContext';
export function BuildYourOwnPage() {
  const {
    t
  } = useLanguage();
  const [params] = useSearchParams();
  const raw = parseInt(params.get('qty') ?? '1', 10);
  const initialQty = Number.isNaN(raw) ? 1 : Math.max(1, Math.min(pricingConfig.maxIndividualQty, raw));
  return <>
      <PageHeader title={<>{t('byo.headline')}</>} lead="Professional-grade lighting in exactly the quantity you need — one M1 PRO for a fountain, fifteen for a custom layout. No bundle required." data-id="element-1186" data-mp="2rs1jw0amlum7" />
      <section className="mx-auto max-w-site px-5 py-16 md:px-8 md:py-24" data-id="element-1187" data-mp="1zzketgpq4j48">
        <BuildYourOwn initialQty={initialQty} data-id="element-1188" data-mp="241yyu454pox3" />
        <p className="mt-12 text-titanium" data-id="element-1189" data-mp="240nv24booh5z">
          Lighting 4 or more?{' '}
          <Link to="/systems" className="font-semibold text-ice underline-offset-4 hover:underline" data-id="element-1190" data-mp="105hnkh8qoizg">
            Compare Complete Lighting Systems
          </Link>{' '}
          — systems of 2, 4, 6, 8, 12 and 24 lights cost less than the same number of individual lights.
        </p>
      </section>
    </>;
}